import "./Protocols.css";
import SpotlightCard from "../SpotlightCard/SpotlightCard";

function Protocols() {
  return (
    <div>
      <div className="protocols_title">Protocols</div>
      <ul className="protocol_list">
        <li>
          <a href="https://eips.ethereum.org/EIPS/eip-7654" target="_blank">
            <SpotlightCard
              className="custom-spotlight-card"
     
            >
              <div className="protocol_item_tag">EIP-7654</div>
              <div className="protocol_item_title">Request Method Types</div>
              <p>
                <br />
                Use a set of request methods to indicate the type of action to
                take on the contract.
              </p>
            </SpotlightCard>
          </a>
        </li>
        <li>
          <a href="https://eips.ethereum.org/EIPS/eip-7566" target="_blank">
            <SpotlightCard
              className="custom-spotlight-card"
          
            >
              <div className="protocol_item_tag">EIP-7566</div>
              <div className="protocol_item_title">
                Onchain Communication Protocol
              </div>
              <p>
                A communication channel that facilitates interaction between
                users in onchain Apps.
              </p>
            </SpotlightCard>
          </a>
        </li>
        <li>
          <a
            href="https://github.com/AmeNetwork/Model-Smart-Contract-Protocol"
            target="_blank"
          >
            <SpotlightCard
              className="custom-spotlight-card"
            
            >
              <div className="protocol_item_tag">MSCP</div>
              <div className="protocol_item_title">
                Model Smart Contract Protocol
              </div>
              <p>
                A standard protocol that enables LLM applications to interact
                with EVM-compatible networks.
              </p>
            </SpotlightCard>
          </a>
        </li>
      </ul>
    </div>
  );
}

export default Protocols;
